import type { AuthRepositoryInterface, AuthResult } from '../../domain/interfaces/AuthRepositoryInterface';
import type { LoginData } from '@/types';

export class LoginUseCase {
  constructor(private readonly authRepository: AuthRepositoryInterface) {}

  async execute(credentials: LoginData): Promise<AuthResult> {
    return this.authRepository.login(credentials);
  }
}
